export default __webpack_public_path__ + "static/media/talent-main-section-article2-Mask-Group-Dev-IT.72bfb8ac.svg";